import './reset-password-controller';
import './recuperar-senha-sucesso';
import './nova-senha';
import './recuperar-senha-falha';
import './nova-senha-sucesso';